import SidebarContext from 'state/SidebarContext';
import { useContext, useState } from 'react';
import { ContentStateTypes, NotOptedInTypeMain } from 'types/uiTypes';
import SuggestShippingContainer from './SuggestionStates/SuggestShippingContainer';
import ContentState from './SuggestionStates/ContentState';
import ErrorState from './SuggestionStates/ErrorState';
import LoadingState from './SuggestionStates/LoadingState';

const SuggestShipping = () => {
    const { uiText } = useContext(SidebarContext);
    const [state, setState] = useState<ContentStateTypes>('content');
    const content = state === 'content';
    const loading = state === 'loading';
    const error = state === 'error';

    const [uiResponse, setUiResponse] = useState<NotOptedInTypeMain>(uiText);

    if (!uiResponse.context.suggestionStatus) return null;

    return (
        <SuggestShippingContainer>
            {loading && <LoadingState />}
            {error && <ErrorState />}
            {content && (
                <ContentState
                    setState={setState}
                    setUiResponse={setUiResponse}
                    uiText={uiResponse}
                />
            )}
        </SuggestShippingContainer>
    );
};

export default SuggestShipping;
